import { transactions } from '../endpoints';
import { Api } from '../api';
import type { ApiPaginate, ApiResponse, FileResponse } from '../../models';
import type { CreateTransactionReceiptRequest, TransactionRequest, TransactionResponse, UpdateTransactionRequest } from './models';

export class TransactionsApi extends Api {
  static getList = (request?: TransactionRequest, signal?: AbortSignal) =>
    this.get<ApiPaginate<TransactionResponse[]>>({ url: transactions.getList(), queryParams: request, signal });

  static updateTransaction = (request: UpdateTransactionRequest) =>
    this.put<UpdateTransactionRequest, ApiResponse<TransactionResponse>>({ url: transactions.updateTransaction(), data: request });

  static createReceiptTransaction = ({ refNum, receipt }: CreateTransactionReceiptRequest) =>
    this.post<FormData, ApiResponse<TransactionResponse>>({ url: transactions.createReceiptTransaction(refNum), data: receipt });

  static removeReceipt = (refNum: string, signal?: AbortSignal) =>
    this.delete<undefined, ApiResponse<TransactionResponse>>({ url: transactions.removeReceiptTransaction(refNum), signal });

  static getReceipt = (id: string, signal?: AbortSignal) => this.get<FileResponse>({ url: transactions.getReceiptTransaction(id), signal });
}
